import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './principalDesk.component.html',
	styleUrls: ['./principalDesk.component.css']
})

export class PrincipalDeskComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/principalDesk/principalDesk.component.ts